// extracted by mini-css-extract-plugin
export default {"root":"VMatchSquadsClub_root_kN0Fn","onField":"VMatchSquadsClub_onField_1xUo9","onBench":"VMatchSquadsClub_onBench_fTDv3","squadSubtitle":"VMatchSquadsClub_squadSubtitle_2AhJ2"};